<!-- *************************************************************************
	TEMPLATE
	************************************************************************* -->
<template>
  <div>
    <PageTitle
      title="Warehouse View"
      :backBtn="true"
      :editRoute="'edit/' + this.$route.params.id"
    />

    <v-container fluid class="lighten-12 container">
      <v-row>
        <v-col v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title warehosuetiltle"
              ><v-icon color="blue" small>mdi-warehouse</v-icon
              ><span class="ml-3"> Warehouse Details</span></v-card-title
            >

            <v-container
              fluid
              class="light gray lighten-12 warehousedetailscard"
            >
              <v-row class="category-detail">
                <v-col cols="12" lg="6" class="py-0">
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                    <v-row>
                      <v-col cols="8" sm="12" md="8" lg="8" class="pt-4 pr-0">
                        <v-row class="pt-1 pr-0 warehousename">
                          {{ warehouse.name }}
                        </v-row>
                        <v-row class="pt-1 pr-0">
                          <v-chip
                            style="
                              color: white;
                              font-variant-caps: all-small-caps;
                              font-weight: bold;
                            "
                            text-color="white"
                            dark
                            label
                            :color="getStatusColor(warehouse.is_active)"
                          >
                            {{ warehouse.is_active ? 'Active' : 'Archived' }}
                          </v-chip>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" class="pt-0">
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                    <v-row>
                      <v-col cols="6" sm="12" md="6" lg="6" class="pt-2 pl-0">
                        <span class="subtextlable">Phone</span>
                      </v-col>
                      <v-col
                        cols="6"
                        sm="12"
                        md="6"
                        lg="6"
                        class="pt-3 pl-0 textbold"
                      >
                        <a href="">
                          {{ warehouse.phone }}
                        </a>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="12" md="6" lg="6" class="pt-1 pl-0">
                        <span class="subtextlable">Address</span>
                      </v-col>
                      <v-col
                        cols="6"
                        sm="12"
                        md="6"
                        lg="6"
                        class="pt-1 pl-0 textbold"
                      >
                        {{ warehouse.address }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="12" md="6" lg="6" class="pt-1 pl-0">
                        <span class="subtextlable">Description</span>
                      </v-col>
                      <v-col
                        cols="6"
                        sm="12"
                        md="6"
                        lg="6"
                        class="pt-1 pl-0 textbold"
                      >
                        {{
                          warehouse.description ? warehouse.description : '---'
                        }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title warehosuetiltle"
              ><v-icon color="blue" small>mdi-bulletin-board</v-icon
              ><span class="ml-3">
                Warehouse Related Factors</span
              ></v-card-title
            >

            <v-container
              fluid
              class="light gray lighten-12 warehousedetailscard"
            >
              <v-tabs horizontal background-color="primary" dark class="pt-0">
                <v-tab> Products </v-tab>
                <v-tab> Purchases </v-tab>
                <v-tab> Purchase order </v-tab>
                <!-- <v-tab> Purchase return </v-tab> -->
                <!-- <v-tab> Shops</v-tab> -->
                <v-tab-item>
                  <WarehouseProductList :WarehouseId="$route.params.id" />
                </v-tab-item>

                <v-tab-item>
                  <WarehousePurchase :WarehouseId="$route.params.id" />
                </v-tab-item>
                <v-tab-item>
                  <WarehousePurchaseOrder :WarehouseId="$route.params.id" />
                </v-tab-item>
                <!-- <v-tab-item>
                  <WarehousePurchaseReturn :WarehouseId="$route.params.id" />
                </v-tab-item> -->
                <!-- <v-tab-item>
                  <WarehouseShop :WarehouseId="$route.params.id" />
                </v-tab-item> -->
              </v-tabs>
            </v-container>
          </v-card>
        </v-col>

        <v-col v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title warehosuetiltle"
              ><v-icon color="blue" small>mdi-content-paste</v-icon
              ><span class="ml-3"> Recent Logs</span></v-card-title
            >

            <v-container
              fluid
              class="light gray lighten-12 warehousedetailscard"
            >
              <v-col cols="12" sm="12" md="12" lg="12">
                <AuditLogs :Type="'ware_houses'" />
              </v-col>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<!-- *************************************************************************
	SCRIPT
	************************************************************************* -->
<script>
import { Warehouse } from '../../../../../models/Warehouse';
//COMPONENTS

import WarehouseProductList from './WarehouseProductList';
import WarehousePurchase from './WarehousePurchaseList';
import WarehousePurchaseOrder from './WarehousePurchaseOrderList';
import WarehousePurchaseReturn from './WarehousePurchaseReturnList';
import WarehouseShop from './WarehouseShopList';
import LineChart from '@/components/Charts/LineChart';
import PieChart from '@/components/Charts/PieChart';
import ColumnChart from '@/components/Charts/ColumnChart';

export default {
  data() {
    return {
      warehouse: {
        type: Object,
        default: {},
      },
    };
  },

  components: {
    WarehousePurchaseOrder,
    WarehousePurchaseReturn,
    WarehousePurchase,
    WarehouseShop,
    LineChart,
    PieChart,
    ColumnChart,

    WarehouseProductList,
  },
  methods: {
    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },
    GetWarehouse() {
      let warehouseId = this.$route.params.id;

      this.$store
        .dispatch('warehouse/GetWarehouseSingleId', warehouseId)
        .then((res) => {
          this.warehouse = new Warehouse().Initialise(res.data);
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
  },
  created() {
    this.GetWarehouse();
  },
};
</script>
<style scoped>
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
  margin-bottom: -16px;
}
.warehosuetiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.warehousedetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.warehousename {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.textbold {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  color: #000000;
}
</style>
